document.addEventListener('DOMContentLoaded', () => {
    const table = document.querySelector('.ProductMeta__Description table');
    if (!table) return;
    
    // Add class to table
    table.classList.add('diamond-details');
    
    // Remove colgroup if present
    const colgroup = table.querySelector('colgroup');
    if (colgroup) colgroup.remove();
    
    // Remove height, width, and style attributes from table
    table.removeAttribute('height');
    table.removeAttribute('width');
    table.removeAttribute('style');
    
    // Add table header
    const thead = document.createElement('thead');
    thead.innerHTML = `
        <tr>
            <th>CHARACTERISTIC</th>
            <th>DETAILS</th>
        </tr>`;
    table.prepend(thead);
    
    // Define icon mappings (sorted alphabetically)
    const iconMap = [
        { keyword: 'bezel material', icon: 'fi-rr-info' },
        { keyword: 'box and paper', icon: 'fi-rr-box' },      
        { keyword: 'brand', icon: 'fi-rr-badge-check' },
        { keyword: 'bracelet color', icon: 'fi-rr-palette' },
        { keyword: 'bracelet length', icon: 'fi-rr-ruler-combined' },
        { keyword: 'bracelet material', icon: 'fi-rr-info' },
        { keyword: 'case diameter', icon: 'fi-rr-ring' },
        { keyword: 'case material', icon: 'fi-rr-info' },
        { keyword: 'clarity', icon: 'fi-rr-eye' },
        { keyword: 'clasp', icon: 'fi-rr-info' },
        { keyword: 'color', icon: 'fi-rr-palette' },
        { keyword: 'condition', icon: 'fi-rr-condition' },
        { keyword: 'crystal', icon: 'fi-rr-gem' },
        { keyword: 'cut grade', icon: 'fi-rr-benefit-diamond' },
        { keyword: 'dealer product code', icon: 'fi-rr-handshake' },
        { keyword: 'designer', icon: 'fi-rr-benefit-diamond-alt' },
        { keyword: 'dial', icon: 'fi-rr-watch' },
        { keyword: 'functions', icon: 'fi-rr-time-watch-calendar' },
        { keyword: 'gender', icon: 'fi-rr-info' },
        { keyword: 'gemstone', icon: 'fi-rr-gem' },
        { keyword: 'gia', icon: 'fi-rr-diploma' },
        { keyword: 'length', icon: 'fi-rr-measuring-tape' },
        { keyword: 'location', icon: 'fi-rr-marker' },
        { keyword: 'marked/tested', icon: 'fi-rr-test' },
        { keyword: 'measurements', icon: 'fi-rr-ruler-combined' },
        { keyword: 'metal', icon: 'fi-rr-ring-diamond' },
        { keyword: 'model', icon: 'fi-rr-model-cube-space' },
        { keyword: 'movement', icon: 'fi-rr-watch' },
        { keyword: 'note', icon: 'fi-rr-document' },
        { keyword: 'number of stones', icon: 'fi-rr-hastag' },
        { keyword: 'polish', icon: 'fi-rr-gem' },
        { keyword: 'product id', icon: 'fi-rr-id-badge' },
        { keyword: 'reference number', icon: 'fi-rr-info' },
        { keyword: 'scope of delivery', icon: 'fi-rr-truck-check' },
        { keyword: 'shape', icon: 'fi-rr-info' },
        { keyword: 'shipping', icon: 'fi-rr-shipping-fast' },
        { keyword: 'size', icon: 'fi-rr-ruler-combined' },
        { keyword: 'style', icon: 'fi-rr-ring' },
        { keyword: 'symmetry', icon: 'fi-rr-diamond' },
        { keyword: 'table', icon: 'fi-rr-table-layout' },
        { keyword: 'title', icon: 'fi-rr-diamond' },
        { keyword: 'video', icon: 'fi-rr-video-camera-alt' },
        { keyword: 'weight', icon: 'fi-rr-scale' },
        { keyword: 'width', icon: 'fi-rr-ruler-horizontal' },
        { keyword: 'year of production', icon: 'fi-rr-calendar-day' }
    ];
    
    // Modify existing rows
    const rows = table.querySelectorAll('tbody tr');
    rows.forEach(row => {
        const labelCell = row.children[0];
        let labelText = labelCell.textContent.trim().replace(/:$/, '').toLowerCase(); // Remove trailing colon if present and convert to lowercase
        
        const iconEntry = iconMap.find(entry => labelText.includes(entry.keyword));
        
        if (iconEntry) {
            labelCell.innerHTML = `<i class="fi ${iconEntry.icon}"></i> ${labelCell.textContent.trim().replace(/:$/, '')}`;
        } else {
            labelCell.innerHTML = `<i class="fi fi-rr-info"></i> ${labelCell.textContent.trim().replace(/:$/, '')}`;          
        }
      
        // Add target="_blank" to links in the value cell
        const valueCell = row.children[1];
        const links = valueCell.querySelectorAll('a');
        links.forEach(link => {
            link.setAttribute('target', '_blank');
        });
        
        // Remove height, width, and style attributes from td and tr
        row.removeAttribute('height');
        row.removeAttribute('width');
        row.removeAttribute('style');
        
        [...row.children].forEach(td => {
            td.removeAttribute('height');
            td.removeAttribute('width');
            td.removeAttribute('style');
        });
    });
});